import RouterSection from '@/Layout/components/RouterSection';
import { checkedUserHasEverLoggedIn, checkPaymentResult } from '@/router/NavigationGuards'

export default {
  path: '/',
  component: RouterSection,
  mode: 'history',
  children: [
    // 로그인
    {
      path: 'login',
      name: 'login',
      component: () => import('@/views/login/Login'),
      beforeEnter: checkedUserHasEverLoggedIn,
    },
    // 비밀번호 변경
    {
      path: 'changepwd',
      name: 'changepwd',
      component: () => import('@/views/login/ChangePassword'),
    },
    // 비밀번호 찾기
    {
      path: 'findpwd',
      name: 'findpwd',
      component: () => import('@/views/login/FindPassword'),
    },
    // 비밀번호 재설정 초기
    {
      path: 'findpwdset',
      name: 'findpwdset',
      component: () => import('@/views/login/ChangePassword/InitalPassword'),
    },
    // 비밀번호 재설정 완료
    {
      path: 'findpwdok',
      name: 'findpwdok',
      component: () => import('@/views/login/FindPassword/Success'),
    },
    // 비밀번호 재설정 임시비밀번호
    {
      path: 'findpwdex',
      name: 'findpwdex',
      component: () => import('@/views/login/FindPassword/Reset'),
    },
    // 아이디 찾기
    {
      path: 'findid',
      name: 'findid',
      component: () => import('@/views/login/FindId'),
    },
    // 아이디 찾기 완료
    {
      path: 'findidok',
      name: 'findidok',
      component: () => import('@/views/login/FindId/Success'),
    },
    // 서브회원 최초 로그인 인증
    {
      path: 'smsCertification',
      name: 'smsCertification',
      component: () => import('@/views/login/SubMemberSmsCertification')
    },
    // 결제 결과 
    {
      path: 'paymentresult',
      name: 'paymentresult',
      beforeEnter: checkPaymentResult,
    },
    // 결제 실패
    {
      path: 'paymenterror',
      name: 'paymenterror',
      component: () => import('@/views/error/PaymentError')
    },
  ],
};
